import React from "react";
import { useSelector } from "react-redux";
import Button from "../../../../../../../../common/Button";

const MoreSizeComparison = () => {

  const keypad = useSelector( state => state.keypad );

  return (
    <div className="more_key">
      <table className="key_tbl" summary="키패드">
        <tbody>
        <tr>
          <td><Button className={ '0' === keypad.moreKeyIndex ? 'fill' : null } more-key-index="0" more-key-latex="<"><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_lessthan.svg` } alt="" /></Button></td>
          <td><Button className={ '1' === keypad.moreKeyIndex ? 'fill' : null } more-key-index="1" more-key-latex="\leq"><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_lessthanequal.svg` } alt="" /></Button></td>
        </tr>
        <tr>
          <td><Button className={ '2' === keypad.moreKeyIndex ? 'fill' : null } more-key-index="2" more-key-latex=">"><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_morethan.svg` } alt="" /></Button></td>
          <td><Button className={ '3' === keypad.moreKeyIndex ? 'fill' : null } more-key-index="3" more-key-latex="\geq"><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_morethanequal.svg` } alt="" /></Button></td>
        </tr>
        </tbody>
      </table>
    </div>
  );

};

export default MoreSizeComparison;
